import React, { useState } from "react";
import { timeOptions } from "./timeOptions";
import { handleTime } from "../../../StudentData/handlers/timeHandler";
import { X } from "lucide-react";

const TimeDropdownSS = ({ state, updateState, clearSelection }) => {
  const [open, setOpen] = useState(false);

  const handleSelect = (value) => {
    updateState(handleTime(state, value, false));
    setOpen(false);
  };

 return (
    <div className="relative w-full">
      {!open ? (
        <div
          className="justify-between p-1.5 border border-[#DDDDDD] rounded w-full flex items-center cursor-pointer bg-white"
          onClick={() => setOpen(true)}
        >
         {state.chosenTime ? (
          <span className="flex flex-wrap items-center bg-blue-100 text-[#2763D4]  text-[14px] gap-2 px-2 py-1 rounded-full">
            {state.chosenTime
              && timeOptions.find((o) => o.value === state.chosenTime)?.display
            }
            <button onClick={clearSelection} className="text-[#2763D4]">
              <X className="w-3 h-3" />
            </button>
          </span>
         ) : (
            <span className="flex flex-wrap items-center text-[14px] bg-blue-100 text-[#2763D4] text-[14px] gap-2 px-2 py-1 rounded-full">All Time
              <button onClick={clearSelection} className="text-[#2763D4]">
                <X className="w-3 h-3" />
              </button>
            </span>
         )}
          <svg
            className="w-3 h-3 text-gray-600 mr-2 justify-end"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 10 6"
            fill="currentColor"
          >
            <path d="M0 0l5 6 5-6H0z" />
          </svg>
        </div>
      ) : (
        <div className="w-full border border-[#DDDDDD] rounded p-3">
          <div className="flex items-center justify-between">
            <span className="text-[14px]">Select Time Period</span>
            <svg
              onClick={(e) => {
                e.stopPropagation()
                setOpen(!open)
              }}
              className="w-3 h-3 text-gray-600"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 10 6"
              fill="currentColor"
            >
              <path d="M0 0l5 6 5-6H0z" />
            </svg>
          </div>
          <ul className="w-full h-full">
            {timeOptions.map((option) => (
              <li
                key={option.value}
                className="flex items-center py-1 hover:bg-gray-100 cursor-pointer"
                onClick={() => handleSelect(option.value)}
              >
                <input
                  type="checkbox"
                  checked={state.chosenTime === option.value}
                  readOnly
                  className="mr-2 appearance-none w-4 h-4 border border-1 rounded"
                  style={{
                    backgroundColor: state.chosenTime === option.value
                    ? "#2763D4"
                    : "transparent",
                  }}
                />
                <span className="text-[14px]">{option.display}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default TimeDropdownSS;
